// TEMPORARY - delete this file once the backend is on dev.
//
// The commodity contract month mapping endpoints exist in RavenBackend
// (CommoditiesController) but not yet in the deployed API the committed client was
// generated from, so `src/Generated/Commodity-Management-Api` has no methods for them.
//
// Regenerating the whole client from a LOCAL build was tried and rejected: local master
// also renames HedgePlanSettings* to HedgePlan* (backend migration V16), which is not on
// dev yet. Pulling that in would break both hedge plan screens at compile time and point
// them at endpoints the dev API does not serve.
//
// So: this module hand-mirrors exactly what the generator emits for these two
// operations - same types, same names, same loading-state-setter-first signature.
// Once the backend reaches dev, run
//
//     npm run openapi:dev:commodity-management
//
// then delete this file and import the four types plus the two methods from
// '../Generated/Commodity-Management-Api' instead. The call sites do not change apart
// from the import path, and the hedge plan rename gets picked up at the same time.
import globalAxios, { AxiosRequestConfig } from 'axios';
import { BASE_PATH } from '../Generated/Commodity-Management-Api/base';
import { LoadingState } from '../Types';

/** Mirrors the generated `ContractYearOffset` enum. */
export const ContractYearOffset = {
    Current: 'Current',
    Next: 'Next',
    Previous: 'Previous',
} as const;

export type ContractYearOffset = typeof ContractYearOffset[keyof typeof ContractYearOffset];

export interface CommodityContractMonthMappingModel {
    'commodityContractMonthMappingId': number;
    'commodityId': number;
    'budgetMonth': number;
    'contractMonth': number;
    'yearOffset': ContractYearOffset;
}

export interface UpdateCommodityContractMonthMappingModel {
    'budgetMonth': number;
    'contractMonth': number;
    'yearOffset': ContractYearOffset;
}

export interface ListCommodityContractMonthMappingsResponse {
    'rows'?: Array<CommodityContractMonthMappingModel> | null;
    'totalCount'?: number;
}

export interface UpdateCommodityContractMonthMappingsResponse {
    'mappings'?: Array<CommodityContractMonthMappingModel> | null;
}

type LoadingStateSetter = null | undefined | ((state: LoadingState) => void | undefined | null);

/** Drives the loading state around a request the way the generated wrapper does. */
function track<T>(promise: Promise<T>, loadingStateSetter: LoadingStateSetter): Promise<T> {
    if (loadingStateSetter) {
        loadingStateSetter(LoadingState.Loading);
        promise.then(() => loadingStateSetter(LoadingState.Loaded));
        promise.catch(() => loadingStateSetter(LoadingState.Failed));
    }

    return promise;
}

export function listCommodityContractMonthMappings(
    loadingStateSetter: LoadingStateSetter,
    commodityId?: number,
    options?: AxiosRequestConfig,
) {
    return track(
        globalAxios.get<ListCommodityContractMonthMappingsResponse>(
            `${BASE_PATH}/commodity-management/commodities/contract-month-mappings`,
            { ...options, params: { ...(options?.params ?? {}), commodityId } },
        ),
        loadingStateSetter,
    );
}

export function updateCommodityContractMonthMappings(
    loadingStateSetter: LoadingStateSetter,
    commodityId: number,
    mappings: Array<UpdateCommodityContractMonthMappingModel>,
    options?: AxiosRequestConfig,
) {
    return track(
        globalAxios.put<UpdateCommodityContractMonthMappingsResponse>(
            `${BASE_PATH}/commodity-management/commodities/${encodeURIComponent(commodityId)}/contract-month-mappings`,
            { commodityId, mappings },
            options,
        ),
        loadingStateSetter,
    );
}
